import { render, staticRenderFns } from "./SignUpSMSAuth.vue?vue&type=template&id=2e2cf10c"
import script from "./SignUpSMSAuth.vue?vue&type=script&lang=js"
export * from "./SignUpSMSAuth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports